<template>
	<div @click="$emit('click',$event)">
		FOOTER
	</div>
</template>

<script>
export default {
	name: "Footer",

	props: [],

	components: {},

	data: function () {
		return {}
	},

	mounted() {
	},

	beforeDestroy() {
	},

	methods: {},

	computed: {},

}
</script>

<style scoped lang="scss">

</style>